<template lang="pug">
  #navbar(ref="navbar")
    .navbar__content(v-if="isMobile")
      .logo(ref="logo")
        img(src="../assets/images/logo-white.png")
      a(@click="menuActive = true")
        font-awesome-icon.icon.alt(icon="bars")
      .menu(v-show="menuActive")
        button.close(@click="menuActive = false")
          font-awesome-icon.icon.alt(icon="times")
        ul.links
          li.link__item(v-for="(link) in menu.links")
            a(:href="link.link == '' ? '#' : link.link", :class="{ active: isActiveLink(link.link) }") {{ link.name }}
        ul.social-networks
          li.social-network__item(v-for="(socialNetwork) in menu.socialNetworks")
            a(:href="socialNetwork.href", target="_blank")
              font-awesome-icon.icon.alt(:icon="['fab', socialNetwork.icon]")
    .navbar__content(v-else)
      .logo(ref="logo")
        img(src="../assets/images/logo-white.png")
      .menu
        ul.links
          li.link__item(v-for="(link) in menu.links")
            a(:href="link.link == '' ? '#' : link.link", :class="{ active: isActiveLink(link.link) }") {{ link.name }}
        ul.social-networks
          li.social-network__item(v-for="(socialNetwork) in menu.socialNetworks")
            a(:href="socialNetwork.href", target="_blank")
              font-awesome-icon.icon.alt(:icon="['fab', socialNetwork.icon]")
</template>

<script>

export default {
  name: "NavBar",
  data: () => ({
    menu: {
      links: [
        { name: "Home", link: "" },
        { name: "Serviços", link: "#ourservices" },
        { name: "Por que nós?", link: "#why-choose-us" },
        { name: "Depoimentos", link: "#what-they-say-about-us" }
      ],
      socialNetworks: [
        {
          icon: "facebook-f",
          href: 'http://facebook.com/revisacarslz'
        },
        {
          icon: "instagram",
          href: 'http://instagram.com/revisacarslz'
        },
        {
          icon: "twitter",
          href: 'http://twitter.com/revisacarslz'
        }
      ],
      scrolled: false,
      navbar: '',
      logo: '',
    },
    menuActive: false,
    isMobile: false
  }),
  created() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
  },
  mounted() {
    this.navbar = this.$refs.navbar
    this.logo = this.$refs.logo
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    isActiveLink(link) {
      if (this.$route.hash === link) {
        return true
      }
      return false
    },
    handleScroll() {
      this.scrolled = window.scrollY
      let windowHeight = window.innerHeight
      let navbar = document.querySelectorAll('#navbar')[0]
      if (this.scrolled >= (windowHeight - 100)) {
        this.navbar.style['background-color'] = 'rgba(0,0,0,.8)'
        this.logo.style['background-color'] = 'transparent'
      }else {
        this.navbar.style['background-color'] = 'transparent'
        this.logo.style['background-color'] = '#B41D22'
      }
    },
    handleResize() {
      let windowWidth = window.innerWidth
      if (windowWidth < 1366) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/resources'

#navbar
  position fixed
  width 100%
  display flex
  justify-content center
  z-index 999
  transition background-color .25s ease

  .navbar__content
    width 1366px
    display flex
    justify-content space-between
    align-items center

    .logo
      width 250px
      height 100px
      display flex
      justify-content center
      align-items center
      box-sizing border-box
      background-color $revisacar-red
      border-radius 0 0 20px 20px
      transition background-color .25s ease

      img
        width 80%

    .menu
      display flex
      align-items center

      ul
        float left

        li
          float left
          list-style none

          &.link__item
            a
              display block
              margin 0 15px
              font-weight 600
              font-size 16px
              text-decoration none
              color rgba(white, .5)
              outline 0

              &.active
                position relative
                color white

                &:before
                  content ''
                  position absolute
                  bottom -3px
                  display block
                  width 80%
                  height 3px
                  background-color $revisacar-red

          &.social-network__item
            a
              display block
              margin 0 15px
              color white

        &.links
          margin-right 30px

        &.social-networks
          background-color rgba(black, .3)
          padding 10px
          border-radius 30px
          box-sizing border-box

@media (max-width: 1366px)
  #navbar
    .navbar__content
      position relative
      padding 0 15px
      box-sizing border-box
      .logo
        width 150px
        height 60px
      a
        display block
        color white
        font-size 25px
      .menu
        position fixed
        top 0
        left 0
        display flex
        flex-direction column
        justify-content center
        width 100%
        height 100%
        background-color rgba(black, 7)
        .close
          position fixed
          top 0
          right 0
          width 80px
          height 80px
          color white
          background-color transparent
          border 0
          outline 0
          font-size 20px
        ul
          float left
          .link__item
            float none
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue